module.exports = __webpack_public_path__ + "img/IMG_1149_FoamcoreMatted.b99870a5.jpg";